import { render, staticRenderFns } from "./BuyingCosts.vue?vue&type=template&id=5d888490&"
import script from "./BuyingCosts.vue?vue&type=script&lang=js&"
export * from "./BuyingCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports